var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"full-screen",attrs:{"align":"center","justify":"center"}},[_c('v-img',{attrs:{"src":"/loader.gif","contain":"","height":"150","width":"150"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }